<template>
  <div class="main-wrapper">
    <v-card class="task-manager-wrapper">
      <div class="header">
        <h1 class="header-title">
          <span v-if="task && task.id && task.workOrder">WO {{ task.workOrder.workOrderNumber }} - {{ task.taskNumber }}</span>
          <span v-else>Task</span>
        </h1>
        <v-btn small icon color="white" class="btn-exit" @click="closeWindow">
          <v-icon size="32">close</v-icon>
        </v-btn>
      </div>
      <div v-show="!isCheckListSaved || !isInitiationSaved" class="alert">  <v-icon size="45" color="white">mdi-content-save-alert-outline</v-icon> <span v-show="!isCheckListSaved"> {{checklistUnsavedMessage}} <v-icon size="45" color="white">mdi-content-save-alert-outline</v-icon></span> <span v-show="!isInitiationSaved"> {{initiationUnsavedMessage}} <v-icon size="45" color="white">mdi-content-save-alert-outline</v-icon></span>  </div>
      <v-stepper style="box-shadow: none;" v-model="step" vertical>
        <v-stepper-step class="stepper-step" color="#b4b4b4" editable :complete="step > 1" step="1">
          Initiation
        </v-stepper-step>
        <v-stepper-content class="stepper-content" step="1">
          <initiation :initiationSaved="setInitiationSaved"></initiation>
        </v-stepper-content>

        <v-stepper-step class="stepper-step" color="#f8da36" editable :complete="step > 2" step="2">
          Planning
        </v-stepper-step>
        <div v-if="this.task !== null">
          <v-stepper-content class="stepper-content" step="2">
            <planning :checklistSaved="setChecklistSaved" :isSaved="isCheckListSaved"></planning>
          </v-stepper-content>
        </div>
        <v-stepper-step class="stepper-step" color="#2196f3" editable :complete="step > 3" step="3">
          Execution
        </v-stepper-step>
        <div v-if="this.task !== null">
          <v-stepper-content class="stepper-content" step="3">
            <execution></execution>
          </v-stepper-content>
        </div>
        <v-stepper-step v-if="this.userRole === 'Admin'" class="stepper-step" color="#9B5094" editable :complete="step > 4" step="4">
          Field Complete
        </v-stepper-step>
        <div v-if="this.task !== null">
          <v-stepper-content class="stepper-content" step="4">
            <field-complete></field-complete>
          </v-stepper-content>
        </div>
        <v-stepper-step v-if="this.userRole === 'Admin'" class="stepper-step" color="#67df91" editable :complete="step > 5" step="5">
          Close Out
        </v-stepper-step>
        <div v-if="this.task !== null">
          <v-stepper-content class="stepper-content" step="5">
            <close-out></close-out>
          </v-stepper-content>
        </div>
      </v-stepper>
    </v-card>
    <template>
      <v-row justify="center">
        <v-dialog v-model="closeConfirmDialog" persistent max-width="290">
          <v-card>

            <v-toolbar color="primary"
                       flat>
              <v-toolbar-title style="color: #ffffff; font-weight: 500;" v-html="`Unsaved Data`"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="white" style="margin-right: 1px;" icon class="text-right ml-3" @click="closeConfirmDialog = false">
                <v-icon color="#ffffff" size="32">close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text style="margin-top:10px;" class="pb-1"> Are you sure you wish to close the task manager? <br> <div v-if="!isCheckListSaved">{{checklistUnsavedMessage}}</div> <br> <div v-if="!isInitiationSaved">{{initiationUnsavedMessage}}</div></v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn outlined color="error" :to="page">Leave Page</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>
<script>
import Initiation from '@/components/workorders/taskManagerSteps/Initiation'
import Planning from '@/components/workorders/taskManagerSteps/Planning'
import Execution from '@/components/workorders/taskManagerSteps/Execution'
import FieldComplete from '@/components/workorders/taskManagerSteps/FieldComplete'
import CloseOut from '@/components/workorders/taskManagerSteps/CloseOut'
import { mapGetters, mapActions } from 'vuex'
import Edit from "@/components/scheduling/Edit";

export default {
  name: 'TaskManagerView',
  components: {
    Initiation,
    Planning,
    Execution,
    FieldComplete,
    CloseOut
  },
  props: {
    page: {
      type: String,
      default: '/work-orders' // Default back to work orders
    },
    type: String
  },
   async created() {
     if (this.task !== null) {
       await this.loadDocs(this.task.id)
       await this.loadImages({ taskId: this.task.id, size: 'small' })
       await this.loadChangeOrders(this.task.id)
       await this.loadWorkOrderNumbers(this.task.id)
     } else {
       this.clearDocs()
       this.clearImages()
       this.clearChangeDoc()
     }
  },
  data () {
    return {
      editable: true,
      isCheckListSaved: true,
      isInitiationSaved: true,
      closeConfirmDialog: false,
      checklistUnsavedMessage: 'The checklist has unsaved changes.',
      initiationUnsavedMessage: 'The initiation details has unsaved changes.'
    }
  },
  methods: {
    ...mapActions({
      loadDocs: 'document/loadDocsByTask',
      loadImages: 'image/loadImagesByTask',
      loadChangeOrders: 'changeOrder/loadByTask',
      loadWorkOrderNumbers: 'workOrder/loadWorkOrderNumbers',
      clearDocs: 'document/clearDocumentTasks',
      clearImages: 'image/clearImageTasks',
      clearChangeDoc: 'changeOrder/clearChangeTasks'
    }),
    setChecklistSaved(value) {
      this.isCheckListSaved = value
    },
    setInitiationSaved(value) {
      this.isInitiationSaved = value
    },
    closeWindow() {
      if (this.isCheckListSaved && this.isInitiationSaved) {
        if(this.page === '/calendar') {
          this.$router.push({path: this.page, name: 'Calendar', params: {calendarType: this.type}})
        }
        else {
          this.$router.push({path: this.page})
        }
      } else {
        this.closeConfirmDialog = true
      }
    }
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      step: 'workOrderTask/step',
      userRole: 'user/role',

    })
  }
}
</script>
<style scoped>

  .main-wrapper {
    height: 100%;
    max-width: 100%;
    position: fixed;
    overflow: hidden;
    right: 0;
    left: 256px;
  }

  .task-manager-wrapper {
    height: calc(100% - 32px);
    margin: 16px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .header {
    height: 70px;
    background-color: #1e345d;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    position: sticky;
    z-index: 3;
    top: 0;
  }

  .alert{

    height: 70px;
    background-color:#FF5252;
    position: sticky;
    z-index: 10;
    top: 70px;
    color: #fff;
    font-size: 28px;
    text-align:center;
    padding: 15px 0 0 0;
  }


  .header-title {
    color: #fff;
    font-size: 28px;
    float: left;
    margin: 15px 0 0 16px;
  }

  .btn-exit {
    float: right;
    margin: 15px 16px 0 0;
  }

  @media only screen and (max-width: 1263px) {
    .main-wrapper {
      left: 0;
    }
    .task-manager-wrapper {
      height: calc(100% - 96px);
    }
  }
  @media only screen and (max-width: 959px) {
    .task-manager-wrapper {
      height: calc(100% - 88px);
    }
  }
  @media only screen and (max-width: 820px) {
    .stepper-content {
      margin-left: 0 !important;
      border-left: none !important;
    }
    .stepper-step {
      padding: 12px 12px 12px !important;
    }
  }
  @media only screen and (max-width: 420px) {
    .stepper-content {
     margin: -8px -60px -16px 0 !important;
     padding: 16px 60px 16px 0 !important;
    }
    .header {
      height: 58px;
    }
    .header-title {
      font-size: 20px;
    }
    .btn-exit {
      margin: 10px 10px 0 0;
    }
  }
</style>
